import React, { useEffect, useState } from "react";
import { Eye, EyeOff, Landmark, MessageSquareReply } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../../../lib/api";
import { Stars } from "../../AvisVoyageur";

export function ConnectBanner() {
  const [st, setSt] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/str/connect/status").then((r) => setSt(r.data)).catch(() => {}); }, []);
  if (!st || st.ready || !st.direct_active) return null;
  return (
    <button onClick={() => navigate("/app/saisonnier/reservation-directe")} className="w-full flex items-center gap-3 rounded-2xl bg-amber-50 border border-amber-200 px-5 py-3 text-left text-sm text-amber-900 hover:bg-amber-100 transition-colors" data-testid="connect-banner">
      <Landmark className="w-5 h-5 shrink-0" /><span className="flex-1"><b>Activez vos versements</b> pour recevoir les paiements de vos réservations directes directement sur votre compte bancaire.</span><span className="font-semibold">Activer →</span>
    </button>
  );
}

function ReviewRow({ r, reload }) {
  const [rep, setRep] = useState(r.reponse || "");
  const [open, setOpen] = useState(false);
  const save = async (patch) => { try { await api.put(`/str/reviews/${r.id}`, { reponse: rep, masque: r.masque, ...patch }); toast.success("Avis mis à jour"); setOpen(false); reload(); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } };
  return (
    <div className={`px-4 py-3 border-b border-brand-soft last:border-0 text-sm ${r.masque ? "opacity-50" : ""}`} data-testid={`review-row-${r.id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <Stars value={r.note} size="w-4 h-4" />
        <span className="font-semibold text-brand-greenDeep">{r.prenom}</span>
        <span className="text-xs text-brand-green/50">{r.property_name} · séjour {r.sejour}</span>
        <div className="ml-auto flex gap-1">
          <button onClick={() => setOpen(!open)} title="Répondre" className="p-1.5 rounded-full hover:bg-brand-softer" data-testid={`review-reply-${r.id}`}><MessageSquareReply className="w-4 h-4" /></button>
          <button onClick={() => save({ masque: !r.masque })} title={r.masque ? "Afficher" : "Masquer"} className="p-1.5 rounded-full hover:bg-brand-softer" data-testid={`review-hide-${r.id}`}>{r.masque ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}</button>
        </div>
      </div>
      {r.commentaire && <p className="text-brand-green/70 mt-1">« {r.commentaire} »</p>}
      {r.reponse && !open && <p className="text-xs text-brand-green/60 mt-1 pl-3 border-l-2 border-brand-lime">Votre réponse : {r.reponse}</p>}
      {open && <div className="flex gap-2 mt-2"><input value={rep} onChange={(e) => setRep(e.target.value)} placeholder="Réponse publique" className="flex-1 px-3 py-2 rounded-full border border-brand-soft text-xs" data-testid={`review-reply-input-${r.id}`} />
        <button onClick={() => save({})} className="px-3 py-2 rounded-full bg-brand-greenDeep text-white text-xs font-semibold" data-testid={`review-reply-save-${r.id}`}>Publier</button></div>}
    </div>
  );
}

export function ReviewsPanel() {
  const [rv, setRv] = useState(null);
  const load = () => api.get("/str/reviews").then((r) => setRv(r.data));
  useEffect(() => { load(); }, []);
  if (!rv) return null;
  const avg = rv.length ? (rv.reduce((a, x) => a + x.note, 0) / rv.length).toFixed(1) : null;
  return (
    <div className="bg-white rounded-2xl border border-brand-soft" data-testid="reviews-panel">
      <h2 className="px-4 py-3 border-b border-brand-soft font-semibold text-brand-greenDeep text-sm flex items-center gap-2">Avis voyageurs {avg && <span className="text-xs px-2 py-0.5 rounded-full bg-brand-lime/40" data-testid="reviews-avg">{avg}/5 · {rv.length} avis</span>}</h2>
      {rv.length === 0 ? <p className="px-4 py-6 text-sm text-brand-green/50" data-testid="reviews-empty">Les voyageurs reçoivent une invitation à noter leur séjour le lendemain du départ.</p> : rv.map((r) => <ReviewRow key={r.id} r={r} reload={load} />)}
    </div>
  );
}
